/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import { sKeylist } from '../../service/dictionary/dataitem';
import { list } from '../../service/notice';
import { Store, Actions } from './store';

class InfoList extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      filterBoxVisible: false,
      notice_type: [],
      rows: [],
      total: 0,
      searchObj: {
        title: '',
        isPublish: null,
        startDate: '',
        endDate: '',
        type: '',
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'notice' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange({...this.state.searchObj});
    }else{
      Actions.useStoreChange(false);
    }
  }
  componentWillMount () { //准备数据
    const self = this;
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }
    sKeylist({ sKey: 'notice_type' }).then(res => { //类型
      if(res.status){
        let arr = [{ value: '', text: '全部' }];
        res.data.forEach(x => {
          arr.push({value: x.sKey, text:x.name});
        })
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ notice_type: arr })
          }
        }, 200);
      }
    })
  }

  componentDidMount() {
    this.mounted = true;
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }
  getData(){
    const self = this;
    const {searchObj} = this.state;
    list(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }

  goView (url) {
    hashHistory.push(url);
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    const self=this;
    this.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        title: '',
        isPublish: null,
        startDate: '',
        endDate: '',
        type: '',
        //s: 10,
        p: 1,
      }},
		function(){
			self.getData();
    })
  };

  advanceSubmit (form) {
    const self = this;
    this.setState({ filterBoxVisible: false, searchObj: { ...this.state.searchObj, p: 1 } }, function(){
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'publishDate') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          startDate: value.from,
          endDate: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }

  render () {
    const { filterBoxVisible, rows, total, searchObj, notice_type } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'title',
            label: '主题',
            text: '输入关键词',
            defaultValue: searchObj.title,
            type: 'default'
          },
          {
            name: 'type',
            label: '分类',
            text: '选择分类',
            defaultValue: searchObj.type,
            options: notice_type,
            type: 'select'
          },
          {
            name: 'publishDate',//startLastOperationTime, endLastOperationTime
            label: '发布时间',
            options: [
              {text: '开始时间'},
              {text: '结束时间'}
            ],
            defaultValue: {
              from: searchObj.startDate || '',
              end: searchObj.endDate || ''
            },
            type: 'dateComp'
          },
          {
            name: 'isPublish',
            label: '状态',
            text: '选择状态',
            dataType: 'number',
            defaultValue: searchObj.isPublish !== null ? searchObj.isPublish+'' : 'null',
            options: [
              { value: null, text: '全部' },
              { value: 1, text: '已发布' },
              { value: 0, text: '已撤回' },
            ],
            multiple: false,//支持多选
            type: 'select'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '主题',
          dataIndex: 'title',
          render: (text, record, index) => {
            return <a href={`#/notice/${record.id}`}>{text}</a>
          }
        }, {
          title: '分类',
          dataIndex: 'typeText'
        }, {
          title: '发布人',
          dataIndex: 'userName'
        }, {
          title: '发布时间',
          dataIndex: 'publishDate',
          render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm') : ''
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['通知公告']} defaultKey={0}>
        <Button icon="plus" onClick={this.goView.bind(this, `/notice/add/0`)}>新增</Button>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
export default withRouter(InfoList);


// WEBPACK FOOTER //
// ./src/routes/notice/list.js